import {
    Autocomplete,
    Button,
    Checkbox,
    InputAdornment,
    Menu,
    MenuItem,
    TextField,
    ToggleButton,
    ToggleButtonGroup,
    Tooltip
} from "@mui/material"
import SearchIcon from "@mui/icons-material/Search";
import Companies from "@mui/icons-material/Business";
import React from "react"
import {Link} from "react-router-dom";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {CompanyFilter, SearchState} from "../pages/PersonaListPage";

interface PersonaSearchInputProps {
    restore: boolean;
    toggleRestore: any;
    handlePersonaNew: any;
    perms: any;
    tags: any;
    search: SearchState;
    updateSearch: any;
    companyFilter: CompanyFilter;
    onCompanyFilterChange: (value: CompanyFilter) => void;
    companyOptions: { id: number, name: string }[];
    showAllCompanies: boolean;
    onShowAllCompaniesChange: (value: boolean) => void;
    isAdmin: boolean;
}

export const PersonaSearchInput: React.FC<PersonaSearchInputProps> = ({
                                                                          restore,
                                                                          toggleRestore,
                                                                          tags,
                                                                          handlePersonaNew,
                                                                          perms,
                                                                          search,
                                                                          updateSearch,
                                                                          companyFilter,
                                                                          onCompanyFilterChange,
                                                                          companyOptions,
                                                                          showAllCompanies,
                                                                          onShowAllCompaniesChange,
                                                                          isAdmin,
                                                                      }) => {

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const filterKeys: (keyof Pick<SearchState, "default" | "reel" | "gmail" | "music" | "article" | "video" | "streamer" | "master" | "systemGenerated">)[] = [
        "default",
        "reel",
        "gmail",
        "music",
        "article",
        "video",
        "streamer",
        "master",
        "systemGenerated",
    ];

    const untickAllFilters = () => {
        filterKeys.forEach((key) => updateSearch(key, false));
    };

    const renderFilterItem = (
        key: keyof Pick<SearchState, "default" | "reel" | "gmail" | "music" | "article" | "video" | "streamer" | "master" | "systemGenerated">,
        label: string
    ) => (
        <MenuItem disableRipple onClick={() => updateSearch(key, !search[key])}>
            <Checkbox checked={search[key]} inputProps={{readOnly: true}}/>
            <span>{label}</span>
        </MenuItem>
    );

    const tagOptions = tags.map((option: any) => {
        const firstLetter = option.name[0].toUpperCase();
        return {
            firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter, ...option,
        };
    });

    return (<>
        <div className="content-header">
            <div className="left" style={{display: "flex"}}>
                <TextField
                    label="Search"
                    style={{marginRight: "10px", marginLeft: "35px", minWidth: "200px"}}
                    onChange={(e) => updateSearch("text", e.target.value)}
                    focused
                    size="small"
                    value={search.text}
                    className="foreInputWhite"
                    InputProps={{
                        startAdornment: (<InputAdornment position="start">
                            <SearchIcon color="primary"/>
                        </InputAdornment>),
                    }}
                />
                <Autocomplete
                    multiple
                    size="small"
                    className="foreInputWhite"
                    renderInput={(params) => <TextField focused style={{width: "250px"}}
                                                        variant="outlined" {...params} label="Tags"/>}
                    options={tagOptions.sort((a: any, b: any) => -b.firstLetter.localeCompare(a.firstLetter))}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    groupBy={(option: any) => option.firstLetter}
                    getOptionLabel={(option) => option.name}
                    onChange={(e, newValue) => updateSearch("tags", newValue)}
                />
                <ToggleButtonGroup
                    color="primary"
                    value={search.spin}
                    exclusive
                    onChange={(e, newValue) => {
                        if (newValue) {
                            updateSearch("spin", newValue)
                        }
                    }}
                    style={{marginLeft: "10px", border: "#1565c0 2px solid"}}
                >
                    <ToggleButton className="testing" value={"new"}>New</ToggleButton>
                    <ToggleButton className="testing" value={"old"}>Old</ToggleButton>
                </ToggleButtonGroup>
                <Button
                    variant="outlined"
                    style={{marginLeft: "10px", border: "#1565c0 2px solid"}}
                    disableElevation
                    onClick={handleClick}
                    endIcon={<KeyboardArrowDownIcon/>}
                >
                    Filter
                </Button>
                <Menu
                    elevation={0}
                    anchorOrigin={{
                        vertical: 'bottom', horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top', horizontal: 'right',
                    }}
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                >
                    <MenuItem disableRipple>
                        <Button variant="outlined" color="primary" fullWidth onClick={untickAllFilters}>
                            Untick All
                        </Button>
                    </MenuItem>
                    {renderFilterItem("default", "Default")}
                    {renderFilterItem("reel", "Reel")}
                    {renderFilterItem("gmail", "Gmail")}
                    {renderFilterItem("music", "Music")}
                    {renderFilterItem("article", "Article")}
                    {renderFilterItem("video", "Video")}
                    {renderFilterItem("streamer", "Streamer")}
                    {renderFilterItem("master", "Master")}
                    {renderFilterItem("systemGenerated", "System Generated")}
                </Menu>
                <Tooltip title="Company" placement="top" arrow>
                    <TextField
                        select
                        focused
                        size="small"
                        className="foreInputWhite"
                        style={{marginLeft: "10px", minWidth: "150px"}}
                        value={companyFilter}
                        onChange={(e) => onCompanyFilterChange(e.target.value as CompanyFilter)}
                        InputProps={{
                            startAdornment: (<InputAdornment position="start">
                                <Companies color="primary"/>
                            </InputAdornment>),
                        }}
                    >
                        <MenuItem value="all">All companies</MenuItem>
                        {showAllCompanies && <MenuItem value="unassigned"><em>Unassigned</em></MenuItem>}
                        {companyOptions.map(company => (
                            <MenuItem key={company.id} value={company.id}>{company.name}</MenuItem>
                        ))}
                    </TextField>
                </Tooltip>
                {isAdmin && <Tooltip title="Show all companies" placement="top" arrow>
                    <ToggleButton
                        value="all"
                        color="primary"
                        size="small"
                        selected={showAllCompanies}
                        onChange={() => onShowAllCompaniesChange(!showAllCompanies)}
                        style={{marginLeft: "10px", border: "#1565c0 2px solid"}}
                    >
                        <Companies/>
                    </ToggleButton>
                </Tooltip>}
            </div>
            <div className="right" style={{display: "flex"}}>
                <Button disabled={perms.p1} style={{marginRight: "10px"}} variant="contained" color="primary"
                        onClick={handlePersonaNew} className="spacer">New</Button>
                {restore ? <Button variant="contained" style={{marginRight: "10px"}} color="primary"
                                   onClick={() => toggleRestore()} className="spacer">Normal</Button> :
                    <Button disabled={perms.p3} variant="contained" style={{marginRight: "10px"}} color="primary"
                            onClick={() => toggleRestore()} className="spacer">Restore</Button>}
                <Link to="/">
                    <Button variant="contained" color="primary">Back</Button>
                </Link>
            </div>
        </div>
    </>)
}
